import { HStack, Separator } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  index: number;
  listLength: number;
  children: ReactNode;
};

export default function CockpitRow({ index, listLength, children }: Readonly<Props>) {
  return (
    <>
      {index !== 0 && <Separator size="md" borderColor="neutral.900" />}
      <HStack
        width="100%"
        paddingLeft={5}
        gap={2}
        height="56px"
        flexShrink={0}
        backgroundColor="neutral.800"
        _hover={{ backgroundColor: 'neutral.700' }}
      >
        {children}
      </HStack>
      {index === listLength - 1 && <Separator size="md" borderColor="neutral.900" />}
    </>
  );
}
